module.exports = __webpack_public_path__ + "static/img/logo.ee946a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mCom/logo.png
// module id = 2O6s
// module chunks = 24